var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", eager: "", "max-width": "400" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card-title",
        { staticClass: "navy darken-1 white--text" },
        [
          _vm.isAdminSet
            ? _c(
                "div",
                [
                  _c(
                    "v-icon",
                    { staticClass: "white--text", attrs: { left: "" } },
                    [_vm._v("edit")]
                  ),
                  _vm._v("\n      Cambia amministratore asta\n    "),
                ],
                1
              )
            : _c("div", [_vm._v("Imposta amministratore asta")]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "white--text",
              attrs: { depressed: "", light: "", icon: "" },
              on: { click: _vm.dismiss },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-sheet",
        {
          staticClass: "white",
          staticStyle: { height: "400px", "overflow-y": "auto" },
        },
        [
          _c("div", { staticClass: "pa-4" }, [
            _c(
              "div",
              { staticClass: "navy--text" },
              [
                !_vm.isAdminSet
                  ? _c("span", [
                      _vm._v(
                        "Prima di iniziare si deve impostare una squadra che agirà da\n          amministratore d'asta."
                      ),
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n        L'amministratore d'asta è l'unica persona che può cambiare le\n        impostazioni, far partire o fermare l'asta etc..."
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-icon",
                  { staticClass: "navy--text", attrs: { small: "" } },
                  [_vm._v("info")]
                ),
                _vm._v(
                  " Non deve essere per\n        forza l'amministratore di lega/divisione."
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "v-icon",
                  { staticClass: "navy--text", attrs: { small: "" } },
                  [_vm._v("info")]
                ),
                _vm._v(
                  " L'amministratore d'asta\n        potrà assegnare tale ruolo a un'altra squadra in qualunque momento\n        (utile se ha completato la rosa e vuole abbandonare l'asta)\n      "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "v-icon",
                  { staticClass: "error--text", attrs: { small: "" } },
                  [_vm._v("warning")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "error--text" }, [
                  _vm._v("\n          L'amministratore d'asta deve rimanere "),
                  _c("b", [_vm._v("SEMPRE ONLINE")]),
                  _vm._v(" o Asta\n          Live si bloccherà."),
                ]),
                _vm._v(
                  '\n        Può essere anche "temporaneamente escluso" dall\'asta se serve (se ha\n        terminato la rosa ad esempio) ma deve comunque rimanere online.\n      '
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.asta_squadre_array.length > 0
            ? _c("v-list", { attrs: { dense: "", nav: "" } }, [
                _c(
                  "div",
                  { staticClass: "lista" },
                  _vm._l(_vm.asta_squadre_array, function (sq) {
                    return _c(
                      "v-list-item",
                      {
                        key: sq.id,
                        attrs: { disabled: _vm.squadraDisabled(sq.id) },
                        on: {
                          click: function ($event) {
                            return _vm.change(sq.id)
                          },
                        },
                      },
                      [
                        _c("v-list-item-avatar", [
                          _c("img", { attrs: { src: _vm.squadra(sq.id).pic } }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _c("span", {
                                staticClass: "stato mx-2",
                                class: _vm.squadraPresenceClass(sq.id),
                              }),
                              _vm._v(_vm._s(sq.name) + "\n            "),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ])
            : _c(
                "div",
                { staticClass: "text-center pa-4" },
                [
                  _c("div", [
                    _vm._v(
                      "\n        Nessuna squadra a cui poter assegnare il ruolo di Amministratore\n        d'asta.\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { rounded: "", small: "", outlined: "" },
                      on: {
                        click: function ($event) {
                          return _vm.checkAllineamentoRose(true)
                        },
                      },
                    },
                    [_vm._v("\n        Check allineamento squadre\n      ")]
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }